import BookingParticipantsService from '@/services/BookingParticipantsService'

export default {
  data () {
    const storedData = this.loadFromStorage() || {}
    const storedParticipants = storedData.participants || []
    
    // Initialize service with offer data first
    this.dx = { 
      participants: new BookingParticipantsService(this.data),
    }

    // If we have stored participants, merge them with the service data
    if (storedParticipants.length) {
      const mergedParticipants = this.dx.participants.data.map((participant, index) => {
        // If we have stored data for this index, merge it
        if (storedParticipants[index]) {
          return {
            ...participant, // Keep original type and title
            ...storedParticipants[index], // Merge stored data
            type: participant.type, // Ensure type from offer is preserved
            title: participant.type === 'adult' ? 'Osoba dorosła' : 'Dziecko',
          }
        }
        return participant
      })

      // Update service with merged data
      this.dx.participants = new BookingParticipantsService(this.data, mergedParticipants)
    }

    return {
      dx: this.dx,
      participants: this.dx.participants.data,
    }
  },

  created () {
    if (this.dropdowns) {
      this.dropdowns.gender = [ false, ...this.participants ].map(() => false)
      this.dropdowns.manualChildValidation = [ false, ...this.participants ].map(() => false)
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/booking/logic/Participants.js